import { CancellationStatuses, Status } from '@/common/enums/Status';
import {
	OfferTransportList,
	ReservationOfferTransport,
	ReservationOfferTransportWithInsurance,
} from '@/new-transport/_models/transport-list.model';
import { countryFromLocation } from '@/_utils/country-from-location';
import { Location, Slot } from '@/reservation/reservation.model';

const LUGGAGE_SERVICE_TYPE_ID = 84;

function getLuggageNames(slot: Slot): string {
	return slot.slotServices
		.filter((slotService) => slotService.service.serviceType?.id === LUGGAGE_SERVICE_TYPE_ID)
		.map((slotService) => slotService.service.name)
		.join(', ');
}

export function mapOfferTransportList(offerTransport: ReservationOfferTransport[]): OfferTransportList[] {
	return offerTransport.flatMap((item) => {
		const offer = item as ReservationOfferTransportWithInsurance;
		return item.slot
			.filter((value) => !CancellationStatuses.includes(value.status as Status))
			.map((slotItem) => {
				const slot = slotItem as unknown as Slot;
				return {
					...item,
					slot,
					reservationSlotCount: item.slot.length,
					destination: countryFromLocation(item.product.location[0] as unknown as Location),
					luggageNames: getLuggageNames(slot),
					insurance: offer.insurance,
					medicalInsuranceName: offer.insurance?.name ?? '',
				};
			})
			.sort((a, b) => {
				const dateA = new Date(a.slot.stopDeparture?.['timeDeparture']);
				const dateB = new Date(b.slot.stopDeparture?.['timeDeparture']);
				return dateA.getTime() - dateB.getTime();
			});
	});
}
